import { render, staticRenderFns } from "./CustomerReachingOutNotification.vue?vue&type=template&id=16a1e59e&scoped=true&"
import script from "./CustomerReachingOutNotification.vue?vue&type=script&lang=js&"
export * from "./CustomerReachingOutNotification.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReachingOutNotification.vue?vue&type=style&index=0&id=16a1e59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1e59e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
